export const allowedClockInDifferenceInMinutes = 60;
export const allowedClockOutDifferenceInMinutes = 120;
